import { render, staticRenderFns } from "./contentCourseLiveAddNameCheck.vue?vue&type=template&id=7d820a6d&"
import script from "./contentCourseLiveAddNameCheck.vue?vue&type=script&lang=js&"
export * from "./contentCourseLiveAddNameCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports